<template>

  <b-container flex>
    <div style="padding-top: 20px; padding-bottom: 10px"><span
        style="font-weight: bold; font-size:large; padding-top: 20px; padding-bottom: 10px">Yield Data</span>
    </div>
    <b-row style="margin-bottom: 5px ">
      <b-col sm="9">Vineyard Acreage:</b-col>
      <b-col sm="3">
        <b-form-input v-model="vineyardAcreage" @change="updateProductionData"
                      type="number" step="0.01" min="0.00" max="10000000.00" :readonly="isViewer"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row style="margin-bottom: 5px ">
      <b-col sm="9">Yield (Total Tons):</b-col>
      <b-col sm="3">
        <b-form-input v-model="totalTons" :readonly="isViewer"
                      @change="updateProductionData"></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12"></b-col>
    </b-row>
  </b-container>
</template>

<script>
import Bus from "@/eventBus";
import {mapActions} from "vuex";

export default {
  name: "VineyardProduction",
  props: {year: Number, groupId: String}
  , data() {
    return {
      id: '',
      myGroupId: this.groupId,
      myYear: this.year,
      isViewer: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('VIEWER'),
    }
  },
  watch: {
    year: function (newVal, oldVal) {
      this.myYear = newVal;
      console.log("Load Production Data After Year Update");
      //this.$store.dispatch('loadProductionData');
    },
    groupId: function (newVal, oldVal) {
      this.myGroupId = newVal;
      //this.loadProductionData();
      console.log("Load Production Data After Group Id Update In Vineyard Production Control");
      //this.$store.dispatch('loadProductionData');
    }
  },
  mounted() {
    let self = this;
    console.log("Load Production Data On Mount");
    console.log("Production Year:" + self.myYear);
    this.$store.dispatch('loadProductionData');
  },
  computed: {
    totalTons: {
      get() {
        return this.$store.getters.totalTons;
      },
      set(value) {
        this.$store.commit('totalTons', Number(value));
      }
    },
    vineyardAcreage: {
      get() {
        return this.$store.getters.vineyardAcreage;
      },
      set(value) {
        this.$store.commit('vineyardAcreage', Number(value));
      }
    }
  },
  methods: {
    ...mapActions({
      updateProductionData: 'updateProductionData'
    }),
    sendUpdate: function () {
      let yieldData = {
        year: Number(this.myYear),
        vineyardAcreage: Number(this.vineyardAcreage) || 0,
        totalTons: Number(this.totalTons) || 0
      }
      Bus.$emit('yield-data', yieldData);
    },
    // acreageChanged: function (value, field) {
    //   //TODO This is where I re-enable Database update
    //   //this.sendUpdate();
    //   console.log(`Acreage Changed Field: ${field} Value: ${value}`);
    //   // if (field === 'totalTons'){
    //   //   this.$store.commit('totalTons',value);
    //   // }
    //   let self = this;
    //   self.vineyardAcreage = Number(self.vineyardAcreage) || 0;
    //   self.totalTons = Number(self.totalTons) || 0;
    //
    //   let vineyardProduction = {
    //     _id: this.$store.getters.vineyardProductionId,
    //     groupId: self.myGroupId,
    //     vineyardAcreage: self.vineyardAcreage,
    //     totalTons: self.totalTons,
    //     year: self.myYear
    //   }
    //
    //   let vineyardProductionJson = JSON.stringify(vineyardProduction, null, 3);
    //   this.$http.post("metrics/production/data/vineyard/" + self.myGroupId, vineyardProductionJson
    //       , {
    //         headers: {
    //           'content-type': 'application/json'
    //         }
    //       }).then(response => {
    //     if (self.id === undefined || self.id === '') {
    //       self.id = response.data._id;
    //     }
    //     console.log("Production Data Post", response);
    //   });
    // }
  }
}
</script>

<style scoped>

</style>
